import { useCallback, useState } from 'react';
import { usePreviewDocuSignMutation } from '@/store/query/offer-Initiation';
import type { SendEsignPayload } from '@/pages/settings-revamp/modules/ESignatureSettings/esignature.types';

interface PreviewArgs {
  id: string;
  payload: SendEsignPayload;
}

// Single-button "Preview on Docusign": one fast request creates the draft envelope AND returns the
// sender-view URL, then we redirect the current tab to it (same-tab, no popup — avoids the popup
// blocker entirely). DocuSign returns the recruiter to the offer page (returnUrl) after they
// send/schedule. The button shows a loader (isRunning) until the redirect kicks in.
export const useDocusignPreviewFlow = () => {
  const [previewDocuSign] = usePreviewDocuSignMutation();
  const [isRunning, setIsRunning] = useState(false);

  const runPreview = useCallback(
    async ({ id, payload }: PreviewArgs) => {
      setIsRunning(true);
      try {
        const res = await previewDocuSign({ id, payload });
        const url = 'data' in res ? res.data?.url : undefined;
        if ('error' in res || !url) throw new Error('preview_error');
        window.location.href = url;
      } catch (error) {
        setIsRunning(false);
        throw error;
      }
    },
    [previewDocuSign]
  );

  return { runPreview, isRunning };
};
